<template>
  <ContentWrap>
    <el-alert
      title="标签库供 C 端人脉匹配点选；改库后下次预计算生效，不会清空用户已选标签。"
      type="info"
      :closable="false"
      class="mb-16px"
    />
    <el-tabs v-model="active">
      <el-tab-pane v-for="item in groups" :key="item.key" :label="item.label" :name="item.key">
        <div class="mb-12px flex gap-8px">
          <el-input v-model="draft[item.key]" placeholder="新增标签（2-16字）" maxlength="16" class="!w-280px" />
          <el-button type="primary" @click="addTag(item.key)">添加</el-button>
          <el-button
            v-hasPermi="['bosscircle:tag-lib:update']"
            type="success"
            :loading="saving"
            @click="save(item.key)"
          >保存本组</el-button>
        </div>
        <el-tag
          v-for="tag in libs[item.key]"
          :key="tag"
          class="m-4px"
          closable
          @close="removeTag(item.key, tag)"
        >{{ tag }}</el-tag>
        <el-empty v-if="!libs[item.key]?.length" description="暂无标签" />
      </el-tab-pane>
    </el-tabs>
  </ContentWrap>
</template>

<script setup lang="ts">
import * as TagLibApi from '@/api/business/tagLib'

defineOptions({ name: 'BossCircleTagLib' })

const message = useMessage()
const active = ref('supply')
const saving = ref(false)
const groups = [
  { key: 'supply', label: '供给' },
  { key: 'demand', label: '需求' },
  { key: 'interest', label: '兴趣' }
]
const libs = reactive<Record<string, string[]>>({
  supply: [],
  demand: [],
  interest: []
})
const draft = reactive<Record<string, string>>({
  supply: '',
  demand: '',
  interest: ''
})

const load = async () => {
  const data = (await TagLibApi.getTagLib()) || {}
  libs.supply = [...(data.supply || [])]
  libs.demand = [...(data.demand || [])]
  libs.interest = [...(data.interest || [])]
}

const addTag = (group: string) => {
  const name = (draft[group] || '').trim()
  if (name.length < 2 || name.length > 16) {
    message.warning('标签需 2～16 字')
    return
  }
  if (libs[group].includes(name)) {
    message.warning('标签已存在')
    return
  }
  libs[group].push(name)
  draft[group] = ''
}

const removeTag = (group: string, tag: string) => {
  libs[group] = libs[group].filter((item) => item !== tag)
}

const save = async (group: string) => {
  saving.value = true
  try {
    await TagLibApi.updateTagLib({ group, tags: libs[group] })
    message.success('已保存')
    await load()
  } finally {
    saving.value = false
  }
}

onMounted(load)
</script>
